import initialState from "../../../../reducers/initialState";
import { DASHBOARD } from "./actions";

const DashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case DASHBOARD.UPDATE_DASHBOARD_COUNTER: {
      return {
        ...state,
        dashboardCounters: action.data,
      };
    }
    case DASHBOARD.SET_CURRENT_DASHBOARD_TAB: {
      return {
        ...state,
        NavTab: action.data,
      };
    }
    default:
      return state;
  }
};

export default DashboardReducer;
